import { render, staticRenderFns } from "./ProductPageSideBarLayout.vue?vue&type=template&id=3cf7cb18&scoped=true"
import script from "./ProductPageSideBarLayout.vue?vue&type=script&lang=js"
export * from "./ProductPageSideBarLayout.vue?vue&type=script&lang=js"
import style0 from "./ProductPageSideBarLayout.vue?vue&type=style&index=0&id=3cf7cb18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7cb18",
  null
  
)

export default component.exports